<template>
    <div>
        <form :action="action" class="registration-form payment-form" :method="method" ref="form" @submit="getStripeToken($event)">
            <input type="hidden" name="_token" :value="csrkToken">

            <div id="link-authentication-element">
                <!-- Elements will create authentication element here -->
            </div>
            <div id="payment-element" ref="paymentElement">
                <!-- Elements will create form elements here -->
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        action: String,
        method: String,
        ccNumberLabel: String,
        expiryLabel: String,
        cvcLabel: String,
        initError: String,
        discoverUrl: String,
        stripeKey: String,
        amount: Number,
    },
    data: () => {
        return {
            stripe: null,
            elements: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            csrkToken: Laravel.csrfToken,
            savedErrors: {},
            submitting: false,
            paymentElement: null,
        };
    },
    async mounted() {
        this.stripe = Stripe(this.stripeKey);
        const subscriptionData = (await axios.post('/api/create-stripe-payment-intent')).data;
        this.elements = this.stripe.elements({
            fonts: [
                {
                    cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic&display=swap'
                }
            ],
            locale: window.appLocale,
            clientSecret: subscriptionData.clientSecret,
        });
        var elementStyles = {
            base: {
                color: '#495057',
                fontWeight: 400,
                fontFamily: 'Roboto',
                fontSize: '16px',
                fontSmoothing: 'antialiased',
                lineHeight: '32px'
            }
        };
        var elementClasses = {
            focus: 'focused',
            empty: 'empty',
            invalid: 'invalid',
        };
        /*this.cardNumber = this.elements.create('cardNumber', {
            placeholder: '',
            classes: elementClasses,
            style: elementStyles
        });
        this.cardNumber.mount(this.$refs.cardNumberInput);
        this.cardExpiry = this.elements.create('cardExpiry', {
            placeholder: '',
            classes: elementClasses,
            style: elementStyles
        });
        this.cardExpiry.mount(this.$refs.cardExpiryInput);
        this.cardCvc = this.elements.create('cardCvc', {
            placeholder: '',
            classes: elementClasses,
            style: elementStyles
        });
        this.cardCvc.mount(this.$refs.cardCvcInput);*/

        this.paymentElement = this.elements.create('payment', {
            paymentMethodOrder: ['card'],
        });
        this.paymentElement.mount(this.$refs.paymentElement);
        const linkAuthenticationElement = elements.create('linkAuthentication');
        linkAuthenticationElement.mount('#link-authentication-element');

        // Listen for errors from each Element, and show error messages in the UI.
        var error = this.$refs.form.querySelector('.error');
        var errorMessage = error.querySelector('.message');
        this.savedErrors = {};
        [this.cardNumber, this.cardExpiry, this.cardCvc].forEach((element, idx) => {
            element.on('change', event => {
                if (event.error) {
                    error.classList.add('visible');
                    this.savedErrors[idx] = event.error.message;
                    errorMessage.innerText = event.error.message;
                } else {
                    this.savedErrors[idx] = null;

                    // Loop over the saved errors and find the first one, if any.
                    var nextError = Object.keys(this.savedErrors)
                        .sort()
                        .reduce((maybeFoundError, key) => {
                            return maybeFoundError || this.savedErrors[key];
                        }, null);

                    if (nextError) {
                        // Now that they've fixed the current error, show another one.
                        errorMessage.innerText = nextError;
                    } else {
                        // The user fixed the last error; no more errors.
                        error.classList.remove('visible');
                    }
                }
            });
        });
    },
    methods: {
        getStripeToken(event) {
            if (this.submitting) {
                return;
            }
            this.submitting = true;
            var error = this.$refs.form.querySelector('.error');
            var errorMessage = error.querySelector('.message');
            // Loop over the saved errors and find the first one, if any.
            var nextError = Object.keys(this.savedErrors)
                .sort()
                .reduce((maybeFoundError, key) => {
                    return maybeFoundError || this.savedErrors[key];
                }, null);

            if (nextError) {
                // Now that they've fixed the current error, show another one.
                errorMessage.innerText = nextError;
                error.classList.add('visible');
                this.submitting = false;
                return;
            } else {
                // The user fixed the last error; no more errors.
                error.classList.remove('visible');
            }

            this.stripe.createSource(this.cardNumber).then(result => {
                var form = this.$refs.form;
                if (result.source) {
                    // Insert the token ID into the form so it gets submitted to the server
                    var hiddenInput = this.$refs.stripeSourceInput;
                    hiddenInput.setAttribute('value', result.source.id);

                    // Submit the form
                    // form.submit();
                } else {
                    this.submitting = false;
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PaymentFormComponent.vue